/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for registering a competitor in an event.
 * 
 * `organization_id` is required for organization events and refused for user events; the
 * service checks it against the event's participation.
 * @export
 * @interface CompetitorCreate
 */
export interface CompetitorCreate {
    /**
     * 
     * @type {string}
     * @memberof CompetitorCreate
     */
    organization_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitorCreate
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetitorCreate
     */
    member_user_ids: Array<string>;
}

/**
 * Check if a given object implements the CompetitorCreate interface.
 */
export function instanceOfCompetitorCreate(value: object): value is CompetitorCreate {
    if (!('member_user_ids' in value) || value['member_user_ids'] === undefined) return false;
    return true;
}

export function CompetitorCreateFromJSON(json: any): CompetitorCreate {
    return CompetitorCreateFromJSONTyped(json, false);
}

export function CompetitorCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitorCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'member_user_ids': json['member_user_ids'],
    };
}

export function CompetitorCreateToJSON(json: any): CompetitorCreate {
    return CompetitorCreateToJSONTyped(json, false);
}

export function CompetitorCreateToJSONTyped(value?: CompetitorCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'name': value['name'],
        'member_user_ids': value['member_user_ids'],
    };
}

